module.exports = __webpack_public_path__ + "static/media/team_david.71ff7503.png";